import React, { useState } from 'react';
import { Radio } from 'antd';
import ReviewBlock from './ReviewBlock';
import QuestionCard from './QuestionCard';
import Button from '@common/Button';
import { ShuffleRounded } from '@mui/icons-material';

const ALL_QUESTIONS = [
    { id: 'q1',  text: 'Solve for x: 2(x + 3) = 5x − 9' },
    { id: 'q2',  text: 'A rectangle has length 3x + 2 and width x − 1. Write a simplified expression for its perimeter.' },
    { id: 'q3',  text: 'Expand and simplify: (x + 4)(x − 2)' },
    { id: 'q4',  text: 'A shopfront offers 15% discount off a $240 jacket. What is the sale price?' },
    { id: 'q5',  text: 'The ratio of boys to girls in a class is 3:4. If there are 28 students, how many are girls?' },
    { id: 'q6',  text: 'Find the gradient of the line passing through (1, 3) and (4, 12).' },
    { id: 'q7',  text: 'Simplify: 4a² × 3a³' },
    { id: 'q8',  text: 'A bag contains 4 red, 3 blue and 5 green marbles. What is the probability of drawing a blue marble?' },
    { id: 'q9',  text: 'Factorise: x² + 7x + 12' },
    { id: 'q10', text: 'The mean of five numbers is 14. Four of the numbers are 10, 12, 18 and 16. Find the fifth number.' },
    { id: 'q11', text: 'A right-angled triangle has legs of 6 cm and 8 cm. Find the length of the hypotenuse.' },
    { id: 'q12', text: 'Write 0.000045 in scientific notation.' },
    { id: 'q13', text: 'A cylinder has radius 3 cm and height 10 cm. Find its volume, giving your answer in terms of π.' },
    { id: 'q14', text: '$2 000 is invested at a simple interest rate of 4% per annum. How much interest is earned after 3 years?' },
    { id: 'q15', text: 'Solve the inequality 3x − 5 > 7 and show the solution on a number line.' },
];

const shuffle = (arr) => {
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
};

const COUNT_OPTIONS = ['3 Questions', '5 Questions', '10 Questions'];

const QuestionsReviewBlock = ({ headerActions, icon = '❓', onRemove }) => {
    const [questionCount, setQuestionCount] = useState('5 Questions');
    const [questionSet, setQuestionSet] = useState(() => ALL_QUESTIONS.slice(0, 5));

    const handleNewSet = () => {
        setQuestionSet(shuffle(ALL_QUESTIONS).slice(0, parseInt(questionCount)));
    };

    const handleSwap = (index) => {
        const currentIds = new Set(questionSet.map(q => q.id));
        const available = ALL_QUESTIONS.filter(q => !currentIds.has(q.id));
        if (!available.length) return;
        const replacement = available[Math.floor(Math.random() * available.length)];
        setQuestionSet(prev => prev.map((q, i) => i === index ? replacement : q));
    };

    return (
        <ReviewBlock
            icon={icon}
            label="Questions"
            onRemove={onRemove}
            headerRight={
                <div className="ch-lesson-planner-review-block-meta">
                    <Button type="text" icon={<ShuffleRounded />} onClick={handleNewSet}>New Set</Button>
                    {headerActions && (
                        <div className="ch-lesson-planner-review-block-header-actions">
                            {headerActions}
                        </div>
                    )}
                </div>
            }
        >
            <Radio.Group
                className="ch-lesson-planner-question-radio"
                options={COUNT_OPTIONS}
                optionType="button"
                buttonStyle="solid"
                value={questionCount}
                onChange={e => {
                    const val = e.target.value;
                    setQuestionCount(val);
                    setQuestionSet(shuffle(ALL_QUESTIONS).slice(0, parseInt(val)));
                }}
            />
            {questionSet.map((item, index) => (
                <QuestionCard
                    key={item.id}
                    number={index + 1}
                    text={item.text}
                    onSwap={() => handleSwap(index)}
                />
            ))}
        </ReviewBlock>
    );
};

export default QuestionsReviewBlock;
